import LoginSidebar from './loginSidebar.component';

export default LoginSidebar;
